/**
 * СГЕНЕРИРОВАНО scripts/build-widgets.mjs — не редактировать вручную.
 * Обновляется командой `pnpm build:widgets`.
 *
 * Bundled-реестр нужен мобильному приложению и офлайн-режиму: те же виджеты,
 * что лежат на CDN, но собранные внутрь хоста. Манифесты при этом не меняются.
 */
import type { BundledRegistry } from '@resto/widget-sdk';

export const BUNDLED_REGISTRY: BundledRegistry = {
  "delivery": {
    htmlUrl: '/widgets/delivery/index.html',
    moduleUrl: '/widgets/delivery/index.js',
    version: "0.1.0",
  },
  "dine-in": {
    htmlUrl: '/widgets/dine-in/index.html',
    moduleUrl: '/widgets/dine-in/index.js',
    version: "0.1.0",
  },
  "booking": {
    htmlUrl: '/widgets/booking/index.html',
    moduleUrl: '/widgets/booking/index.js',
    version: "0.1.0",
  },
  "loyalty": {
    htmlUrl: '/widgets/loyalty/index.html',
    moduleUrl: '/widgets/loyalty/index.js',
    version: "0.1.0",
  },
  "rental": {
    htmlUrl: '/widgets/rental/index.html',
    moduleUrl: '/widgets/rental/index.js',
    version: "0.1.0",
  },
  "services": {
    htmlUrl: '/widgets/services/index.html',
    moduleUrl: '/widgets/services/index.js',
    version: "0.1.0",
  },
  "ai-chat": {
    htmlUrl: '/widgets/ai-chat/index.html',
    moduleUrl: '/widgets/ai-chat/index.js',
    version: "0.1.0",
  },
};

/** Версии собранных бандлов — для отладки и сверки с манифестами. */
export const BUNDLED_VERSIONS: Readonly<Record<string, string>> = {
  "delivery": "0.1.0",
  "dine-in": "0.1.0",
  "booking": "0.1.0",
  "loyalty": "0.1.0",
  "rental": "0.1.0",
  "services": "0.1.0",
  "ai-chat": "0.1.0",
};
